import PoweredBy from '@/components/decoration/PoweredBy';
import { useCanShowBrandedLogo } from '@/components/decoration/mspLogoHelper';
import { Account } from '@/layouts/header/Account';
import { motion } from 'framer-motion';
import { FunctionComponent } from 'react';
import { Settings } from './settings/Settings';
import { useUser } from '@/services/authentication/hooks/user';

interface RightHandSideNavSectionProps {}

const RightHandSideNavSection: FunctionComponent<RightHandSideNavSectionProps> = () => {
  const canShowBrandedLogo = useCanShowBrandedLogo();
  const { email } = useUser();

  return canShowBrandedLogo ? (
    <motion.div layoutId="rightHandSide" className="flex items-center space-x-10">
      <PoweredBy />
      <div className="flex items-center space-x-4">
        {email && <span className="text-sm font-medium text-gray-700">{email}</span>}
        {/*<NotificationBell />*/}
        <Settings />
        <Account />
      </div>
    </motion.div>
  ) : (
    <motion.div layoutId="rightHandSide" className="flex items-center space-x-4">
      {email && <span className="text-sm font-medium text-gray-700">{email}</span>}
      {/*<NotificationBell />*/}
      <Settings />
      <Account />
    </motion.div>
  );
};

export default RightHandSideNavSection;
